function getYoutubeId(url) {
    const link = url ? String(url).trim() : ''
    const match = link.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/)

    return match ? match[1] : ''
}

export function isVideoFileUrl(url) {
    const link = url ? String(url).trim() : ''

    return /\.(mp4|webm|ogv|ogg|mov|m4v)(\?.*)?$/i.test(link)
}

export function getVideoThumbnailUrl(url) {
    const youtubeId = getYoutubeId(url)

    return youtubeId ? `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : ''
}

export function getVideoEmbedUrl(url) {
    const link = url ? String(url).trim() : ''

    if (!link) {
        return ''
    }

    const youtubeId = getYoutubeId(link)

    if (youtubeId) {
        return `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`
    }

    const vimeo = link.match(/vimeo\.com\/(?:video\/)?(\d+)/)

    if (vimeo) {
        return `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`
    }

    // Instagram отдаёт обычные ссылки на reel/post с запретом на встраивание —
    // играть их можно только через /embed.
    const instagram = link.match(/instagram\.com\/(reel|reels|p|tv)\/([\w-]+)/)

    if (instagram) {
        const type = instagram[1] === 'reels' ? 'reel' : instagram[1]

        return `https://www.instagram.com/${type}/${instagram[2]}/embed`
    }

    return link
}
